import React from 'react';
import { Button } from './ui/button';
import { mockData } from '../mock';

const HeroSection = () => {
  const { restaurant } = mockData;

  return (
    <section id="accueil" className="hero-section pt-[calc(var(--header-h-mobile)+12px)] md:pt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <div className="hero-card">
              <div className="space-y-2">
                <h1 className="text-5xl lg:text-6xl font-serif font-bold text-primary leading-tight">
                  {restaurant.name}
                </h1>
                <p className="text-xl text-secondary font-medium">
                  {restaurant.location}
                </p>
              </div>

              <p className="text-lg text-gray-600 leading-relaxed max-w-xl">
                {restaurant.description}
              </p>

              <p className="text-lg text-gray-600 leading-relaxed max-w-xl">
                Une petite table d'hôtes sans prétention où la passion culinaire rencontre la convivialité.
                Le chef{" "}
                <span className="text-primary font-bold text-xl">
                  {restaurant.chef}
                </span>{" "}
                vous invite à découvrir une cuisine créative et chaleureuse dans un cadre intimiste.
              </p>


              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Button
                  className="btn-primary"
                  onClick={() => document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Découvrir le menu
                </Button>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="aspect-square lg:aspect-[1/1] relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="/assets/gallery/hero.jpg"
                alt="Restaurant Au 4A - Ambiance chaleureuse"
                className="w-full h-full object-cover restaurant-image"
              />
              <div className="absolute inset-0 from-black/20 to-transparent"></div>
            </div>


          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;